import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

import Layout from "@layouts/layout.vue";
import EmptyLayout from "@layouts/empty-layout.vue";
import MainSlider from "@partials/main-slider.vue";
import HomeMenu from "@partials/home-menu.vue";
import PageHome from "@pages/home/home.vue";
import PageAdministration from "@pages/administration/administration.vue";
import PageAdministrationDetail from "@pages/administration/administration-detail.vue";
import PageTeachers from "@pages/teachers/teachers.vue";
import PageTeacherDetail from "@pages/teachers/teacher-detail.vue";
import PageDepartment from "@pages/department/department.vue";
import PageStatic from "@pages/staticPage/staticPage.vue";
import PageRegulatoryDocuments from "@pages/regulatoryDocuments/regulatoryDocuments.vue";
import PageMethodicalMaterials from "@pages/methodicalMaterials/methodical-materials.vue";
import PageMethodicalMaterialsTag from "@pages/methodicalMaterials/methodical-materials-tag.vue";
import PageMethodicalMaterialDetail from "@pages/methodicalMaterials/methodical-material-detail.vue";
import PagePhotoGallery from "@pages/photoGallery/photoGallery.vue";
import PageAlbum from "@pages/photoGallery/album.vue";
import PageNews from "@pages/news/news.vue";
import PageNewsDetail from "@pages/news/news-detail.vue";
import NewsService from "./api/dataSource/api/EducationSystem/PublicWeb/Api/Services/NewsService";




const router = new VueRouter({
  mode: "history",
  routes: [
    {
      //name: "layout",
      path: "/",
      component: Layout,
      children: [
        {
          //name:"home",
          path: "",
          components: {
            default: PageHome,
            mainSlider: MainSlider,
            homeMenu: HomeMenu
          },
          meta: {
            title: "Главная",
            showMap:true
          }
        },
        {
          path: "Администрация",
          component: EmptyLayout,
          children:[
            {
              name: "administration",
              path: "",
              component: PageAdministration,
              meta: {
                title: "Администрация"
              }
            },
            {
              name: "administration-detail",
              path: ":id",
              component: PageAdministrationDetail,
              meta: {
                title: "Администрация"
              }
            }
          ]
        },
        {
          path: "Учительская",
          component: EmptyLayout,
          children:[
            {
              name: "teachers",
              path: "",
              component: PageTeachers,
              meta: {
                title: "Учительская"
              },
            },
            {
              name: "teacher-detail",
              path: ":id",
              component: PageTeacherDetail,
              meta: {
                title: "Учительская"
              }
            }
          ]
        },        
        {
          name: "department",
          path: "Кафедры/:id",
          component: PageDepartment,
          meta: {
            title: "Кафедра"
          }
        },
        {
          name: "staticPage",
          path: "Страница/:code",
          component: PageStatic,
          meta: {
            title: "Страница"
          }
        },
        {
          name: "regulatoryDocuments",
          path: "Нормативные документы", //%20
          component: PageRegulatoryDocuments,
          meta: {
            title: "Документы"
          }
        },

        {
          path: "Методическая-копилка",
          component:EmptyLayout,
          children:[
            {
              name: "methodicalMaterials",
              path: "",
              component: PageMethodicalMaterials,
              meta: {
                title: "Копилка знаний"
              }
            },
            {
              name: "methodicalMaterialsByTag",
              path: "Тэг/:tag",
              component: PageMethodicalMaterialsTag,
              meta: {
                title: "Копилка знаний"
              }
            },
            {
              name: "methodicalMaterialsDetail",
              path: ":id",
              component: PageMethodicalMaterialDetail,
              meta: {
                title: "Копилка знаний"
              }
            },
          ]
        },
        {
          path: "Фотогалерея",
          component: EmptyLayout,
          children:[
            {
              name: "photoGallery",
              path: "",
              component: PagePhotoGallery,
              meta: {
                title: "Фото галерея",
                showMap:true
              }
            },
            {
              name: "album",
              path: ":id",
              component: PageAlbum
            }
          ],
          
        },
        {
          path: "Новости",
          component: EmptyLayout,
          children:[
            {
              name: "news",
              path: "",
              component: PageNews,
              meta: {
                title: "Новости"
              }
            },
            {
              name: "news-detail",
              path: ":code",
              component: PageNewsDetail
            }
          ]
        },
        
      ]
    }
    // {
    //     name: loginRoute.name,
    //     path: "/" + routeLangPrefix + "/login",
    //     component: LoginComponent,
    //     meta: {
    //         allowAnonymous: true,
    //         title: "Авторизация"
    //     }
    // },
    // {
    //     name: '404',
    //     path: "*",
    //     component: LoginComponent,
    //     meta: {
    //         allowAnonymous: true,
    //         title: "Авторизация"
    //     }
    // },
  ]
});

router.beforeEach((to, from, next) => {
 // console.log(to, from, next);
  //var title = Vue.$mainStore.PageTitle;
  // if (to.meta.title) {
  //   if (title) title = `${to.meta.title} | ${title}`;
  //   else title = to.meta.title;
  // }
  // document.title = title;
  // console.log("document.head.title", document.head.title);
  if(!Vue.$mainStore.SchoolInfo){
    Vue.$api.SchoolService.GetSchoolInfoEvent.once(()=>{
      next();
    });
    Vue.$api.SchoolService.GetSchoolInfo();
  }
  else
    next();
  
});

export default router;
